<template>
  <div class="wrap">
    <h2 class="common-header">{{ $t('work_rule_2') }}</h2>
    <div class="by-content">
      <div class="approval-config-tree">
        <el-tree
          class="approval-config-tree"
          ref="tree"
          node-key="id"
          highlight-current
          default-expand-all
          :data="treeList"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
      <component
        class="approval-config-main"
        :is="curNode.comp"
        :audit_type="curNode.audit_type || false"
        v-load="loading"
        @clear-loading="loading = false"
      ></component>
    </div>
  </div>
</template>

<script>
import { treeList } from './conf'
export default {
  data() {
    return {
      treeList: treeList(this),
      curNode: {},
      loading: true
    }
  },
  mounted() {
    this.curNode = treeList(this)[0].children[0]
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(this.curNode)
    })
  },
  methods: {
    handleNodeClick(val) {
      if (val.isLeaf) {
        this.curNode = val
        this.loading = true
        if (val.type) {
          this.$router.push(`/flow/index?type=${val.type}&label=${val.flow}`)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.by-content {
  padding: 0;
  display: flex;
}
.approval-config-tree {
  width: 245px;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
  padding: 15px 0;
}
.approval-config-main {
  display: inline-block;
  padding: 20px;
  border-left: 1px solid #ebebeb;
  width: calc(100% - 245px);
  padding: 10px;
  box-sizing: border-box;
  vertical-align: top;
  /deep/ .el-tree {
    background-color: #f5f5f5;
  }
  /deep/ .el-tree-node__content {
    height: 36px;
    line-height: 36px;
  }
  /deep/ .el-tree-node__content:hover {
    background-color: #fff;
  }
}
</style>
